import { Route } from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { vehicleResolver } from './vehicle.resolver';

export const vehicleRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.Vehicle.List.Title'),
    loadComponent: () =>
      import('./vehicle-list/vehicle-list.component').then(
        (m) => m.VehicleListComponent,
      ),
  },
  {
    path: ':vehicleId',
    children: [
      {
        path: 'detail',
        resolve: { vehicle: vehicleResolver },
        loadComponent: () =>
          import('./vehicle-detail/vehicle.detail.component').then(
            (m) => m.VehicleDetailComponent,
          ),
      },
    ],
  },
];
